import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsHelperService {
  countNotifications: BehaviorSubject<number> = new BehaviorSubject(0);
}
